export const markupsType = {
  absolute: "Ручной",
  percentage: "Авто",
};
export const markupsStatus = {
  active: "Активен",
  draft: "Драфт",
  cancelled: "Отменен",
};
